<template>
  <div class="course-wrapper">
    <div class="course-content">
      <div class="main-title">
        <div class="link-list">
          <span class="text">{{ menu.menu_name }}</span>
          <!-- <el-link
            :type="classId === id ? 'primary' : 'default'"
            class="category"
            v-for="{ id, name } in courseClasses"
            :key="id"
            :underline="false"
            href="javascript:;"
            @click="classId = id"
          >
            {{ name }}
          </el-link> -->
        </div>
        <a
          :href="`/courseList.html?type=1&name=${menu.menu_name}&menuId=${menu.id}`"
          class="more-btn"
          style="margin-top: 6px"
        >
          <span class="btn-text">查看全部</span>
          <i class="iconfont icongengduo"></i>
        </a>
      </div>
      <div class="course-list">
        <template v-if="homeCourseList && homeCourseList.length">
          <CourseCard
            class="home-course-card"
            :course-data="course"
            v-for="course in homeCourseList"
            :key="course.id"
            :show-label="true"
            :userInfo="userInfo"
            :authType="authType"
          >
          </CourseCard>
        </template>
        <div v-else class="no-data">
          <Empty />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CourseCard from "./../../components/CourseCard";
import Live from './Live.vue'
import { Empty } from 'zhs-components'
export default {
  components: {
    CourseCard,
    Live,
    Empty
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    }
  },
  created() {
    this.getAuth()
    this.getHomeCourseList();
  },
  // watch: {
  //   menu() {
  //     console.log('123');
  //     this.getHomeCourseList();
  //   },
  // },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      abbr: this.$config.abbr,
      classId: undefined,
      authType: 0
    };
  },
  methods: {
    async getHomeCourseList() {
      console.log('111');
      const homeCourse = await this.$http.getHomeMooc({
        num: this.menu.num,
        menu_id: this.menu.id
      });
      console.log(homeCourse);
      this.homeCourseList = homeCourse;
    },
    async getAuth() {
      const res2 = await this.$http.getConfigList()
      this.authType = res2.find(item => item.code == '10401') ? res2.find(item => item.code == '10401').auth_type : 0
    }
  },
  
};
</script>

<style lang="scss" scoped>
.course-wrapper {
  position: relative;
  min-height: 408px;
  margin: 0 auto;
  padding: 30px 0 30px;
  .course-content {
    margin: 0 auto;
    width: 1200px;
  }
}

.course-wrapper,
.notice-wrapper {
  vertical-align: top;
}

// .course-wrapper {
//   &:first-child {
//     margin-bottom: 40px;
//   }
// }

.course-wrapper .course-list {
  // margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
}
.home-course-card {
  width: 284px;
  & + .home-course-card {
    margin-right: 21px;
  }
  &:nth-of-type(4n) {
    margin-right: 0;
  }
  &:nth-of-type(n + 6) {
    margin-top: 14px;
  }
}
.category {
  display: inline-block;
  max-width: 140px;
  margin-left: 8px;
}
.main-title {
  display: flex;
  height: 28px;
  // overflow: hidden;
  .link-list {
    flex: 1;
    // margin-top: 6px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    .text {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      letter-spacing: 1px;
    }
  }
  .more-btn {
    flex: 0 0 74px;
    margin-right: 0;
  }
}
</style>